import { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import InterviewSessionsChat from "./InterviewSessionsChat";

export default function InterviewSessions(){
  const { interviewId } = useParams();
  const [sessions, setSessions] = useState([]);
  const navigate = useNavigate();
  

  useEffect(() => {
    if (!interviewId) return;
    axios.get(`${process.env.REACT_APP_API_URL}/api/sessions/${interviewId}/sessions`)
      .then(res => setSessions(res.data))
      .catch(()=>setSessions([]));
  }, [interviewId]);

  return (
    <div className="container">
      <h2>Sessions</h2>
      <div className="card">
        {sessions.length === 0 ? (
          <p className="small">No sessions yet for this interview.</p>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Interviewee</th>
                <th>Score</th>
                <th>Status</th>
                <th>Details</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {sessions.map(s => (
                <tr key={s._id}>
                  <td>{s.interviewee_name}</td>
                  <td>{s.score !== null ? s.score : "N/A"}</td>
                  <td>
                    {s.completed ? <span className="badge success">Completed</span> : <span className="badge inprogress">In Progress</span>}
                  </td>
                  <td>
                    <button className="btn secondary" onClick={()=>navigate(`/sessions/${s._id}`)}>Show Details</button>
                  </td>
                  <td>
                    <button className="btn danger" onClick={async () => {
                        if (!window.confirm("Delete this session?")) return;
                        try {
                          await axios.delete(`${process.env.REACT_APP_API_URL}/api/sessions/${s._id}`);
                          setSessions(prev => prev.filter(sess => sess._id !== s._id));
                        } catch {
                          alert("Failed to delete session");
                        }
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <InterviewSessionsChat interviewId={interviewId} />
      </div>
    </div>
  );
}
